import axios from 'axios';
import { baseURL } from '../constants/constants.js';

// Cria uma instância do axios com a URL base da API
const api = axios.create({
  baseURL
});

// Interceptor para adicionar o Bearer Token em cada requisição
api.interceptors.request.use(
  (config) => {
    // Recupera o token do localStorage (ou de outro armazenamento que você utilizar)
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser?.token) {
      config.headers.Authorization = `Bearer ${storedUser.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;

